__turbopack_context__.v({
  "calculator": "_4t-Ooa_calculator",
  "container": "_4t-Ooa_container",
  "createApplication": "_4t-Ooa_createApplication",
  "createApplicationButton": "_4t-Ooa_createApplicationButton",
  "createApplicationImage": "_4t-Ooa_createApplicationImage",
  "description": "_4t-Ooa_description",
  "fastStart": "_4t-Ooa_fastStart",
  "isHidden": "_4t-Ooa_isHidden",
  "onlineSearch": "_4t-Ooa_onlineSearch",
  "sectionTitle": "_4t-Ooa_sectionTitle",
  "selectTabs": "_4t-Ooa_selectTabs",
  "tabs": "_4t-Ooa_tabs",
  "title": "_4t-Ooa_title",
});
